/* eslint-disable */
import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  Text,
  useDisclosure,
  Icon,
  Spinner,
  VStack,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  Badge,
  DrawerBody,
  DrawerCloseButton,
  Input,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  IconButton
} from "@chakra-ui/react";
import { FaPlayCircle, FaFilePdf, FaLock, FaCheckCircle, FaBrain } from "react-icons/fa";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
// import Payment from "../../Pages/Payment/Payment";
import convertDateFormat from "../../Redux/AdminReducer/action";
import { capitalizeFirstLetter } from "../../Redux/UserReducer/action";
import Navbar from "../UserComponents/UserNavbar";
import { useSelector } from "react-redux";
import Quiz from "./Quiz";
import axios from "axios";
import { useModalToast } from "../../context/GlobalModalToast";

const YouTubeResumer = ({ videoUrl, sectionId, courseId, initialTime, onComplete, token }) => {
  const intervalRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const maxWatchedRef = React.useRef(initialTime || 0);
  const saveTickRef = React.useRef(0);

  let videoId = '';
  if (videoUrl.includes('embed/')) {
    videoId = videoUrl.split('embed/')[1]?.split('?')[0];
  } else if (videoUrl.includes('v=')) {
    videoId = videoUrl.split('v=')[1]?.split('&')[0];
  } else if (videoUrl.includes('youtu.be/')) {
    videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
  } else {
    videoId = videoUrl.split('/').pop()?.split('?')[0];
  }

  const iframeId = `yt-player-${sectionId}`;

  // Pause when user switches tab or minimises window
  React.useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden && playerRef.current) {
        playerRef.current.pauseVideo();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  React.useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    let player;
    const initPlayer = () => {
      player = new window.YT.Player(iframeId, {
        playerVars: {
          origin: window.location.origin
        },
        events: {
          onReady: (event) => {
            playerRef.current = event.target;
            if (initialTime > 0) {
              event.target.seekTo(initialTime, true);
              maxWatchedRef.current = initialTime;
            }
          },
          onStateChange: async (event) => {
            if (event.data === window.YT.PlayerState.PLAYING) {
              // Poll every 2s so seek-ahead is caught quickly
              intervalRef.current = setInterval(async () => {
                if (player && player.getCurrentTime) {
                  const currentTime = Math.round(player.getCurrentTime());
                  const duration = Math.round(player.getDuration());

                  // Seek restriction: snap back if jumped ahead of max watched
                  if (currentTime > maxWatchedRef.current + 2) {
                    player.seekTo(maxWatchedRef.current, true);
                    return;
                  }
                          maxWatchedRef.current = Math.max(maxWatchedRef.current, currentTime);

                  // Save furthest-watched position every 4s (every 2nd tick)
                  saveTickRef.current += 1;
                  if (saveTickRef.current % 2 === 0 && maxWatchedRef.current > 0) {
                    try {
                      const reqToken = token || JSON.parse(localStorage.getItem('user'))?.token || "";
                      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/video-progress`, {
                        courseId,
                        sectionId,
                        position: maxWatchedRef.current,
                        duration
                      }, {
                        headers: { Authorization: `Bearer ${reqToken}` }
                      });
                      if (res.data.progress && onComplete) {
                        onComplete();
                      }
                    } catch (e) {
                      console.log("Error saving position", e);
                    }
                  }
                }
              }, 2000);
            } else {
              clearInterval(intervalRef.current);
              // Save furthest-watched position on pause too
              if (event.data === window.YT.PlayerState.PAUSED && playerRef.current && maxWatchedRef.current > 0) {
                try {
                  const reqToken = token || JSON.parse(localStorage.getItem('user'))?.token || "";
                  await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/video-progress`, {
                    courseId,
                    sectionId,
                    position: maxWatchedRef.current,
                    duration: Math.round(playerRef.current.getDuration?.() || 0)
                  }, {
                    headers: { Authorization: `Bearer ${reqToken}` }
                  });
                } catch (e) {
                  console.log("Error saving position on pause", e);
                }
              }
              if (event.data === window.YT.PlayerState.ENDED) {
                try {
                  const reqToken = token || JSON.parse(localStorage.getItem('user'))?.token || "";
                  await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/progress`, {
                    courseId,
                    sectionId
                  }, {
                    headers: { Authorization: `Bearer ${reqToken}` }
                  });
                  if (onComplete) onComplete();
                } catch (e) {
                  console.log("Error marking video completed", e);
                }
              }
            }
          }
        }
      });
    };

    if (window.YT && window.YT.Player) {
      initPlayer();
    } else {
      window.onYouTubeIframeAPIReady = initPlayer;
    }

    return () => {
      clearInterval(intervalRef.current);
      if (player && player.destroy) player.destroy();
    };
  }, [videoId, sectionId, courseId, initialTime, iframeId, onComplete, token]);

  return (
    <iframe
      id={iframeId}
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
      src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1&start=${initialTime}`}
      title="YouTube Video Player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  );
};

const LocalVideoResumer = ({ videoUrl, sectionId, courseId, initialTime, onComplete, token }) => {
  const videoRef = React.useRef(null);
  const intervalRef = React.useRef(null);
  const maxWatchedRef = React.useRef(initialTime || 0);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [videoUrl]);

  // Pause when user switches tab or minimises window
  React.useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden && videoRef.current && !videoRef.current.paused) {
        videoRef.current.pause();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  // Seek restriction: snap back if user scrubs ahead of max watched position
  const handleSeeking = () => {
    if (videoRef.current && videoRef.current.currentTime > maxWatchedRef.current + 1) {
      videoRef.current.currentTime = maxWatchedRef.current;
    }
  };

  const saveProgress = async () => {
    if (!videoRef.current || maxWatchedRef.current <= 0) return;
    const duration = Math.round(videoRef.current.duration || 0);
    try {
      const reqToken = token || JSON.parse(localStorage.getItem('user'))?.token || "";
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/video-progress`, {
        courseId,
        sectionId,
        position: maxWatchedRef.current,
        duration
      }, {
        headers: { Authorization: `Bearer ${reqToken}` }
      });
      if (res.data.progress && onComplete) {
        onComplete();
      }
    } catch (e) {
      console.log("Error saving local video position", e);
    }
  };

  const handlePlay = () => {
    intervalRef.current = setInterval(() => {
      if (videoRef.current) {
        const currentTime = Math.round(videoRef.current.currentTime);
        if (currentTime > 0) {
          maxWatchedRef.current = Math.max(maxWatchedRef.current, currentTime);
          saveProgress();
        }
      }
    }, 4000);
  };

  const handlePause = () => {
    clearInterval(intervalRef.current);
    saveProgress();
  };

  const handleEnded = async () => {
    clearInterval(intervalRef.current);
    try {
      const reqToken = token || JSON.parse(localStorage.getItem('user'))?.token || "";
      await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/progress`, {
        courseId,
        sectionId
      }, {
        headers: { Authorization: `Bearer ${reqToken}` }
      });
      if (onComplete) onComplete();
    } catch (e) {
      console.log("Error marking local video completed", e);
    }
  };

  React.useEffect(() => {
    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  const onLoadedMetadata = () => {
    setLoaded(true);
    if (videoRef.current && initialTime > 0) {
      videoRef.current.currentTime = initialTime;
      maxWatchedRef.current = initialTime;
    }
  };

  return (
    <video
      ref={videoRef}
      src={videoUrl}
      controls
      onPlay={handlePlay}
      onPause={handlePause}
      onEnded={handleEnded}
      onLoadedMetadata={onLoadedMetadata}
      onSeeking={handleSeeking}
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '12px', backgroundColor: 'transparent' }}
    />
  );
};

export default function SinglePage() {
  const textColor = useColorModeValue("gray.800", "gray.100");
  const subTextColor = useColorModeValue("gray.600", "gray.400");

  const pageBg = useColorModeValue("gray.50", "#0D0F14"); // Deep sleek dark background for dark mode
  
  // Resolving useColorModeValue inline hooks
  const boxBorderColor = useColorModeValue("gray.100", "whiteAlpha.100");
  const chatBgColor = useColorModeValue("white", "whiteAlpha.50");
  const chatInputBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const lockedBgColor = useColorModeValue("gray.100", "whiteAlpha.100");
  const defaultIconBg = useColorModeValue("purple.100", "whiteAlpha.200");
  const defaultIconColor = useColorModeValue("purple.600", "purple.300");
  const contentBoxShadow = useColorModeValue("xl", "2xl");

  const askAiTextColor = useColorModeValue("gray.600", "gray.400");
  const playlistActiveBg = useColorModeValue("purple.100", "whiteAlpha.200");
  const playlistHoverBg = useColorModeValue("gray.100", "whiteAlpha.300");
  const playlistBg = useColorModeValue("gray.50", "whiteAlpha.50");

  const [res, setRes] = useState({});
  const [recommendedCourses, setRecommendedCourses] = useState([]);
  const { toast } = useModalToast();
  const [enrollment, setEnrollment] = useState(null);
  const [showQuiz, setShowQuiz] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isGeneratingQuiz, setIsGeneratingQuiz] = useState(false);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const userStore = useSelector((store) => store.UserReducer);

  const { isOpen: isAiOpen, onOpen: onAiOpen, onClose: onAiClose } = useDisclosure();
  const [aiInput, setAiInput] = useState("");
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [askAi, setAskAi] = useState(false);
  const [replyingToId, setReplyingToId] = useState(null);
  const [replyInput, setReplyInput] = useState("");
  const [expandedReplies, setExpandedReplies] = useState({});

  const handleSendReply = async (threadId) => {
    if (!replyInput.trim()) return;
    const textToSend = replyInput;
    setReplyInput("");
    setReplyingToId(null);
    if (askAi) setIsAiLoading(true);

    try {
      const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
      await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/${id}/chat/${threadId}/reply`, {
        message: textToSend,
        askAi: askAi
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setExpandedReplies(prev => ({ ...prev, [threadId]: true }));
      getSinglePageData(id);
    } catch (err) {
      console.error(err);
      toast({ title: "Failed to post reply", status: "error" });
    } finally {
      setIsAiLoading(false);
    }
  };

  const handleSendAi = async (customPrompt) => {
    const textToSend = customPrompt || aiInput;
    if (!textToSend.trim()) return;

    // Optimistically clear input
    setAiInput("");
    if (askAi) setIsAiLoading(true);

    try {
      const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
      await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/${id}/chat`, {
        message: textToSend,
        askAi: askAi
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Refresh course data to get updated threads
      getSinglePageData(id);
    } catch (err) {
      console.error(err);
      toast({ title: "Failed to post message", status: "error" });
    } finally {
      setIsAiLoading(false);
    }
  };

  const getSinglePageData = useCallback(async (id) => {
    const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
    setLoading(true);
    setError(null);
    try {
      const courseRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/courses/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRes({ course: courseRes.data });

      try {
        const allRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/courses`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const others = (allRes.data.course || []).filter(c => c._id !== id);
        setRecommendedCourses(others.slice(0, 4));
      } catch (e) {
        console.log("Failed to fetch recommendations", e);
      }

      try {
        const enrollRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/enrollments/my-courses`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const currentEnroll = enrollRes.data.find(en => en.courseId && (en.courseId._id || en.courseId) === id);
        setEnrollment(currentEnroll);
      } catch (e) {
        console.log("Enrollment check failed (likely not enrolled)", e);
      }
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || "Failed to load course data");
    } finally {
      setLoading(false);
    }
  }, [userStore?.token]);

  const { isOpen: isOtpOpen, onOpen: onOtpOpen, onClose: onOtpClose } = useDisclosure();
  const [otpInput, setOtpInput] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isOtpSubmitting, setIsOtpSubmitting] = useState(false);

  const handleEnroll = async () => {
    const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
    
    if (res?.course?.isInviteOnly) {
      setOtpInput("");
      setOtpError("");
      onOtpOpen();
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/enroll`, { 
        courseId: id
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      getSinglePageData(id);
    } catch (err) {
      console.log(err);
      toast({ title: err.response?.data?.message || "Failed to enroll in course", status: "info" });
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async () => {
    if (!otpInput.trim()) {
      setOtpError("Please enter a valid 6-digit OTP code.");
      return;
    }

    const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
    setIsOtpSubmitting(true);
    setOtpError("");

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/enroll`, {
        courseId: id,
        otp: otpInput.trim()
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      onOtpClose();
      setOtpInput("");
      getSinglePageData(id);
    } catch (err) {
      console.log(err);
      setOtpError(err.response?.data?.message || "Invalid OTP code. Please check your email.");
    } finally {
      setIsOtpSubmitting(false);
    }
  };

  const handleGenerateQuiz = async () => {
    const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
    setIsGeneratingQuiz(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/${id}/generate-full-quiz`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      getSinglePageData(id);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || err.response?.data || "Failed to generate AI quiz. Make sure course has content.");
    } finally {
      setIsGeneratingQuiz(false);
    }
  };

  const [hasAttemptedOtp, setHasAttemptedOtp] = useState(false);

  const autoEnrollWithOTP = useCallback(async (otpCode) => {
    const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
    if (!token) return;
    
    setLoading(true);
    setHasAttemptedOtp(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/enroll`, { 
        courseId: id,
        otp: otpCode.trim()
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate(location.pathname, { replace: true });
      getSinglePageData(id);
    } catch (err) {
      console.log("Auto-enrollment failed", err);
      // Remove otp from url to stop loop even if it fails
      navigate(location.pathname, { replace: true });
    } finally {
      setLoading(false);
    }
  }, [id, location.pathname, navigate, userStore?.token, getSinglePageData]);

  const isCreatorOrAdmin = userStore?.role === 'admin' || (res?.course?.createdBy === userStore?.userId);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const otpParam = query.get("otp");
    if (otpParam && res?.course && !enrollment && !loading && !hasAttemptedOtp) {
      autoEnrollWithOTP(otpParam);
    }
  }, [location.search, res?.course, enrollment, loading, hasAttemptedOtp, autoEnrollWithOTP]);

  useEffect(() => {
    getSinglePageData(id);
  }, [id, getSinglePageData]);

  useEffect(() => {
    if ((enrollment || isCreatorOrAdmin) && !res?.course?.isLocked && !selectedSection && res?.course?.sections?.length > 0) {
      const incomplete = res.course.sections.find(
        section => !enrollment?.completedSections?.some(id => id.toString() === section._id.toString())
      );
      setSelectedSection(incomplete || res.course.sections[0]);
    }
  }, [enrollment, isCreatorOrAdmin, res?.course, selectedSection]);

  useEffect(() => {
    if (selectedSection && selectedSection.type === 'documentation' && enrollment) {
      const isAlreadyCompleted = enrollment.completedSections.some(id => id.toString() === selectedSection._id.toString());
      if (!isAlreadyCompleted) {
        const markDocumentationCompleted = async () => {
          try {
            const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
            await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/progress`, {
              courseId: id,
              sectionId: selectedSection._id
            }, {
              headers: { Authorization: `Bearer ${token}` }
            });
            setEnrollment(prev => {
              if (!prev) return null;
              const newCompleted = [...prev.completedSections];
              if (!newCompleted.some(id => id.toString() === selectedSection._id.toString())) {
                newCompleted.push(selectedSection._id);
              }
              const totalSections = res?.course?.sections?.length || 1;
              const newProgress = Math.round((newCompleted.length / totalSections) * 100);
              return {
                ...prev,
                completedSections: newCompleted,
                progress: newProgress
              };
            });
          } catch (e) {
            console.log("Error marking doc completed", e);
          }
        };
        markDocumentationCompleted();
      }
    }
  }, [selectedSection, enrollment?.completedSections, id, res?.course?.sections?.length, userStore?.token, enrollment]);

  const renderContent = () => {
    if (res?.course?.isLocked && !isCreatorOrAdmin) {
      return (
        <Box textAlign="center" p={10} bg="red.50" border="1px solid" borderColor="red.200" borderRadius="2xl" boxShadow="sm">
          <Icon as={FaLock} w={12} h={12} color="red.500" mb={4} />
          <Heading size="md" color="red.800">Sequential Learning Lock Active</Heading>
          <Text mt={3} color="red.700" fontWeight="bold" fontSize="sm">
            {res?.course?.lockReason || "This course is currently locked."}
          </Text>
          <Text mt={2} color="gray.600" fontSize="xs">
            To maintain company compliance standards, you must complete the previous course in this learning bundle first.
          </Text>
          <Button mt={6} colorScheme="red" size="sm" borderRadius="xl" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>
        </Box>
      );
    }

    if (!enrollment && !isCreatorOrAdmin) {
      return (
        <Box textAlign="center" p={10} bg="gray.100" borderRadius="md">
          <Icon as={FaLock} w={10} h={10} color="gray.500" mb={4} />
          <Heading size="md">Content Locked</Heading>
          <Text mt={2}>This course is provided by your company. Enroll to start learning.</Text>
          <Button mt={4} colorScheme="blue" isLoading={loading} onClick={handleEnroll}>Enroll Now</Button>
        </Box>
      );
    }

    if (!selectedSection) {
      return null;
    }

    if (selectedSection.type === 'video') {
      const initialTime = enrollment?.videoPositions?.find(
        vp => vp.sectionId.toString() === selectedSection._id.toString()
      )?.position || 0;

      return (
        <Flex direction={{ base: "column", lg: "row" }} gap={6} align="stretch" w="full">
          {/* Video Aspect Frame */}
          <Box flex={selectedSection.transcript ? 3 : 1} position="relative" pb="56.25%" h={0} overflow="hidden" borderRadius="2xl" boxShadow="2xl">
            {selectedSection.isVideoUpload ? (
              <LocalVideoResumer
                key={selectedSection._id}
                videoUrl={selectedSection.content}
                sectionId={selectedSection._id}
                courseId={id}
                initialTime={initialTime}
                onComplete={() => getSinglePageData(id)}
              />
            ) : (
              <YouTubeResumer
                key={selectedSection._id}
                videoUrl={selectedSection.content}
                sectionId={selectedSection._id}
                courseId={id}
                initialTime={initialTime}
                onComplete={() => getSinglePageData(id)}
              />
            )}
          </Box>

          {/* Premium Glassmorphic Transcript Panel */}
          {selectedSection.transcript && (
            <Box 
              flex={1.2} 
              p={6} 
              bg="rgba(107, 70, 193, 0.05)" 
              backdropFilter="blur(8px)"
              borderRadius="2xl" 
              border="1px solid" 
              borderColor="purple.100" 
              boxShadow="inner"
              maxH={{ base: "300px", lg: "450px" }}
              overflowY="auto"
              display="flex"
              flexDirection="column"
            >
              <Heading size="xs" color="purple.800" mb={3} textTransform="uppercase" letterSpacing="1px" display="flex" alignItems="center" gap={2}>
                🗣️ Lecture Transcript
              </Heading>
              <Text fontSize="xs" lineHeight="relaxed" color="gray.700" textAlign="justify" whiteSpace="pre-wrap">
                {selectedSection.transcript}
              </Text>
            </Box>
          )}
        </Flex>
      );
    }

    if (selectedSection.type === 'documentation') {
      const isUrl = selectedSection.content && (
        selectedSection.content.startsWith('http://') || 
        selectedSection.content.startsWith('https://') || 
        selectedSection.content.startsWith('/uploads/') || 
        selectedSection.content.startsWith('/api/uploads/') || 
        selectedSection.content.startsWith('blob:')
      );

      if (!isUrl) {
        return (
          <VStack spacing={6} align="stretch" w="full">
            {/* Header Card */}
            <Box 
              p={6} 
              bg="rgba(107, 70, 193, 0.05)" 
              backdropFilter="blur(8px)" 
              borderRadius="2xl" 
              border="1px solid" 
              borderColor="purple.100" 
              boxShadow="sm"
            >
              <Heading size="md" color="purple.950" mb={1}>📄 {selectedSection.title || "Lesson Document"}</Heading>
              <Text fontSize="xs" color="gray.600">Company Compliance Training & Study Materials</Text>
            </Box>

            {/* Premium Article Container */}
            <Box 
              p={8} 
              bg="white" 
              borderRadius="2xl" 
              border="1px solid" 
              borderColor="gray.200" 
              boxShadow="xl" 
              fontSize="md"
              lineHeight="tall"
              color="gray.800"
            >
              <div 
                style={{ 
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "16px",
                  lineHeight: "1.8"
                }}
                dangerouslySetInnerHTML={{ __html: selectedSection.content }} 
              />
            </Box>
          </VStack>
        );
      }

      const baseUrl = selectedSection.content.startsWith('/') ? `${process.env.REACT_APP_API_URL}${selectedSection.content}` : selectedSection.content;
      const embedUrl = `${baseUrl}#toolbar=0`;

      return (
        <VStack spacing={6} align="stretch" w="full">
          {/* Action Header Card */}
          <Box 
            p={6} 
            bg="rgba(107, 70, 193, 0.05)" 
            backdropFilter="blur(8px)" 
            borderRadius="2xl" 
            border="1px solid" 
            borderColor="purple.100" 
            boxShadow="sm"
          >
            <Flex justify="space-between" align="center" direction={{ base: "column", sm: "row" }} gap={4}>
              <Box>
                <Heading size="md" color="purple.950" mb={1}>📄 {selectedSection.title || "Lesson Document"}</Heading>
                <Text fontSize="xs" color="gray.600">Company Compliance Training & Resource Materials</Text>
              </Box>
              <HStack spacing={3}>
                <Button 
                  as="a" 
                  href={baseUrl} 
                  target="_blank" 
                  colorScheme="purple" 
                  size="sm"
                  borderRadius="full"
                  fontWeight="800"
                  leftIcon={<span>🔗</span>}
                >
                  Open in New Tab
                </Button>
                <Badge colorScheme="purple" p={2} borderRadius="md">
                  View Only
                </Badge>
              </HStack>
            </Flex>
          </Box>

          <Box h="70vh" borderRadius="2xl" overflow="hidden" border="1px solid" borderColor="gray.200" boxShadow="xl" bg="gray.50">
            <iframe
              src={embedUrl}
              width="100%"
              height="100%"
              title={selectedSection.title}
              style={{ border: 'none' }}
            >
              <Box p={10} textAlign="center" mt={20}>
                <Text fontSize="lg" fontWeight="bold" mb={4}>Unable to display PDF inline.</Text>
                <Button as="a" href={baseUrl} target="_blank" colorScheme="purple" size="md">
                  Open Document in New Tab
                </Button>
              </Box>
            </iframe>
          </Box>
        </VStack>
      );
    }

    if (selectedSection.type === 'quiz') {
      const attempts = enrollment?.quizAttempts || [];
      return (
        <Box p={6} bg="white" borderRadius="2xl" border="1px solid" borderColor="purple.150" boxShadow="xl">
          <Heading size="md" color="purple.950" mb={4}>📝 {selectedSection.title}</Heading>
          <Quiz 
            courseId={id} 
            quizContent={selectedSection.content} 
            onComplete={() => {
              getSinglePageData(id);
              setSelectedSection(res?.course?.sections[0]);
            }}
          />
          
          {attempts.length > 0 && (
            <Box mt={6} borderTop="1px solid" borderColor="purple.100" pt={4}>
              <Heading size="xs" color="purple.900" mb={3}>📊 Your Quiz Attempts History</Heading>
              <Stack spacing={2}>
                {attempts.map((att, index) => {
                  const dateStr = att.attemptDate ? new Date(att.attemptDate).toLocaleDateString() : 'N/A';
                  return (
                    <Flex key={index} justify="space-between" align="center" bg={att.passed ? "green.50" : "red.50"} p={3} borderRadius="lg" border="1px solid" borderColor={att.passed ? "green.200" : "red.200"}>
                      <HStack>
                        <Text fontSize="xs" fontWeight="bold" color={att.passed ? "green.700" : "red.700"}>
                          Attempt #{index + 1}: {att.passed ? "Passed ✅" : "Failed ❌"}
                        </Text>
                        <Text fontSize="xs" color="gray.500">({dateStr})</Text>
                      </HStack>
                      <Text fontSize="xs" fontWeight="extrabold" color={att.passed ? "green.800" : "red.800"}>
                        {att.score}%
                      </Text>
                    </Flex>
                  );
                })}
              </Stack>
            </Box>
          )}
        </Box>
      );
    }

    return null;
  };

  if (loading) {
    return (
      <Box h="100vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner size="xl" color="purple.500" thickness="4px" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box>
        <Navbar />
        <Box pt="100px" maxW="600px" mx="auto" textAlign="center">
          <Heading color="red.500">Error</Heading>
          <Text mt={4}>{error}</Text>
          <Button mt={6} colorScheme="purple" borderRadius="xl" onClick={() => getSinglePageData(id)}>Try Again</Button>
        </Box>
      </Box>
    );
  }

  const nonQuizSections = res?.course?.sections?.filter(s => s.type !== 'quiz') || [];
  const completedNonQuizCount = nonQuizSections.filter(s => enrollment?.completedSections?.some(id => id.toString() === s._id.toString())).length;
  const isFinalQuizLocked = !isCreatorOrAdmin && !!enrollment && nonQuizSections.length > 0 && completedNonQuizCount < nonQuizSections.length;

  const allSectionsCount = res?.course?.sections?.length || 0;
  const completedSectionsCount = enrollment?.completedSections?.length || 0;
  const actualProgress = enrollment?.progress || (allSectionsCount > 0 ? Math.round((completedSectionsCount / allSectionsCount) * 100) : 0);

  return (
    <Box bg={pageBg} minH="100vh" pt={{ base: 20, md: 24 }} pb={20}>
      
      {/* OVERARCHING COURSE TITLE */}
      <Box maxW="1600px" mx="auto" px={{ base: 4, md: 8, xl: 12 }} mb={6}>
        <Heading size="2xl" color={textColor} fontWeight="900" letterSpacing="tight">
          {res?.course?.title}
        </Heading>
      </Box>

      <Flex maxW="1600px" mx="auto" px={{ base: 4, md: 8, xl: 12 }} direction={{ base: "column", xl: "row" }} gap={{ base: 8, xl: 12 }}>
        
        {/* LEFT COLUMN: Media & Course Info */}
        <Box flex={4} w="full" minW={0} display="flex" flexDirection="column" gap={6}>
          
          {/* Dynamic Content Viewer (Video/PDF/Quiz) */}
          <Box display={(!selectedSection && enrollment) ? "none" : "block"} borderRadius="2xl" overflow="hidden" boxShadow={contentBoxShadow}>
            {renderContent()}
          </Box>

          {/* Instructor & Metadata (Seamless) */}
          <Flex align="center" justify="space-between" wrap="wrap" gap={4} mt={2}>
            <Flex align="center" gap={4}>
              <Box w="50px" h="50px" borderRadius="full" overflow="hidden" border="2px solid" borderColor="purple.500">
                <img src={`https://ui-avatars.com/api/?name=${res?.course?.teacher || 'Teacher'}&background=random`} alt={res?.course?.teacher} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </Box>
              <Box>
                <Heading size="md" color={textColor} m={0}>{res?.course?.teacher}</Heading>
                <Text fontSize="sm" color={subTextColor}>{res?.course?.category} Instructor</Text>
              </Box>
            </Flex>
            
            <HStack spacing={4}>
              {res?.course?.allowComments !== false && (
                <Button onClick={onAiOpen} bgGradient="linear(to-r, purple.600, blue.600)" color="white" _hover={{ bgGradient: "linear(to-r, purple.700, blue.700)" }} borderRadius="full" size="sm" px={6}>
                  💬 Discussion & FAQs
                </Button>
              )}
              {enrollment ? (
                <Badge colorScheme="green" px={3} py={1} borderRadius="full" fontSize="xs" fontWeight="bold">
                  Progress: {actualProgress}%
                </Badge>
              ) : !isCreatorOrAdmin ? (
                <Button colorScheme="purple" variant="solid" borderRadius="full" size="sm" px={6} onClick={handleEnroll} isLoading={loading}>
                  Enroll Now
                </Button>
              ) : null}
            </HStack>
          </Flex>

          {/* Description & Details */}
          <Box mt={2}>
            <Text fontSize="md" color={subTextColor} lineHeight="1.8" whiteSpace="pre-wrap" maxW="1000px">
              {res?.course?.description}
            </Text>
            <HStack fontSize="sm" color={subTextColor} mt={4} spacing={6}>
              <Text>📅 Published: {convertDateFormat(res?.course?.createdAt)}</Text>
              <Text>📚 {res?.course?.sections?.length || 0} Modules</Text>
            </HStack>
          </Box>

        </Box>

        {/* RIGHT COLUMN: Interaction & Playlist */}
        <Box flex={1} w="full" minW={{ xl: "320px" }} maxW={{ xl: "380px" }} display="flex" flexDirection="column" gap={8}>
          
          {/* Discussion Drawer */}
          <Drawer isOpen={isAiOpen} placement="right" onClose={onAiClose} size="md">
            <DrawerOverlay backdropFilter="blur(4px)" />
            <DrawerContent bg={pageBg}>
              <DrawerCloseButton />
              <DrawerHeader borderBottomWidth="1px" borderColor={boxBorderColor} color={textColor}>
                💬 Live Discussion & FAQs
              </DrawerHeader>
              <DrawerBody p={0} display="flex" flexDirection="column">
                <Flex direction="column" h="100%" bg={chatBgColor} overflow="hidden">
                  <Flex p={4} align="center" justify="space-between" borderBottom="1px solid" borderColor={boxBorderColor}>
                    <HStack>
                      <Box w={2} h={2} bg="green.400" borderRadius="full" />
                      <Heading size="sm" m={0} color={textColor}>Live Discussion</Heading>
                    </HStack>
                    <Text fontSize="xs" color={subTextColor}>{res?.course?.qaThreads?.length || 0} messages</Text>
                  </Flex>

                  <Box flex={1} p={4} overflowY="auto" sx={{ '&::-webkit-scrollbar': { width: '0px' } }}>
                    <VStack spacing={4} align="stretch">
                      {res?.course?.qaThreads?.length === 0 && (
                        <Text fontSize="xs" color={subTextColor} textAlign="center">No messages yet. Start the discussion!</Text>
                      )}

                      {res?.course?.qaThreads?.map((msg, idx) => {
                        const isExpanded = !!expandedReplies[msg._id];
                        const replyCount = msg.replies?.length || 0;
                        return (
                          <VStack key={msg._id || idx} align="stretch" spacing={2} borderBottom="1px solid" borderColor={boxBorderColor} pb={3}>
                            <Flex justify="flex-start" gap={3}>
                              <Box w={8} h={8} borderRadius="full" overflow="hidden" flexShrink={0}>
                                <img src={msg.isAiResponse ? "https://ui-avatars.com/api/?name=AI+Tutor&background=6B46C1&color=fff" : `https://ui-avatars.com/api/?name=${msg.userName}&background=random`} alt="Avatar" />
                              </Box>
                              <Box flex={1}>
                                <Text fontSize="xs" color={textColor} fontWeight="bold" mb={0.5}>
                                  {msg.isAiResponse ? "🤖 AI Tutor" : msg.userName}
                                </Text>
                                <Box fontSize="sm" color={subTextColor} lineHeight="1.5" dangerouslySetInnerHTML={{ __html: msg.message }} />
                                
                                <HStack spacing={4} mt={2} fontSize="xs" color="purple.400">
                                  {!msg.isAiResponse && (
                                    <Text cursor="pointer" fontWeight="bold" onClick={() => setReplyingToId(msg._id)}>
                                      ↩ Reply
                                    </Text>
                                  )}
                                  {replyCount > 0 && (
                                    <Text cursor="pointer" fontWeight="bold" onClick={() => setExpandedReplies(prev => ({ ...prev, [msg._id]: !isExpanded }))}>
                                      {isExpanded ? `▲ Hide replies` : `▼ Show replies (${replyCount})`}
                                    </Text>
                                  )}
                                </HStack>
                              </Box>
                            </Flex>

                            {replyingToId === msg._id && (
                              <Box ml={11} mt={1} p={2} bg={chatInputBg} borderRadius="md">
                                <HStack>
                                  <Input 
                                    value={replyInput}
                                    onChange={(e) => setReplyInput(e.target.value)}
                                    placeholder="Write a reply..."
                                    size="xs"
                                    variant="unstyled"
                                    color={textColor}
                                    autoFocus
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleSendReply(msg._id);
                                      } else if (e.key === 'Escape') {
                                        setReplyingToId(null);
                                      }
                                    }}
                                  />
                                  <IconButton 
                                    icon={<Icon as={FaPlayCircle} w={4} h={4} />} 
                                    colorScheme="purple" 
                                    variant="ghost" 
                                    size="xs"
                                    isRound 
                                    onClick={() => handleSendReply(msg._id)}
                                    isDisabled={!replyInput.trim()}
                                    aria-label="Send reply"
                                    isLoading={isAiLoading}
                                  />
                                  <Button size="xs" variant="ghost" onClick={() => setReplyingToId(null)}>Cancel</Button>
                                </HStack>
                              </Box>
                            )}

                            {isExpanded && replyCount > 0 && (
                              <VStack align="stretch" spacing={3} ml={10} pl={3} borderLeft="2px solid" borderColor="purple.200" mt={2}>
                                {msg.replies.map((reply, ridx) => (
                                  <Flex key={reply._id || ridx} justify="flex-start" gap={2}>
                                    <Box w={6} h={6} borderRadius="full" overflow="hidden" flexShrink={0}>
                                      <img src={reply.isAiResponse ? "https://ui-avatars.com/api/?name=AI+Tutor&background=6B46C1&color=fff" : `https://ui-avatars.com/api/?name=${reply.userName}&background=random`} alt="Avatar" />
                                    </Box>
                                    <Box>
                                      <Text fontSize="xs" color={textColor} fontWeight="bold" mb={0.5}>
                                        {reply.isAiResponse ? "🤖 AI Tutor" : reply.userName}
                                      </Text>
                                      <Box fontSize="xs" color={subTextColor} lineHeight="1.4" dangerouslySetInnerHTML={{ __html: reply.message }} />
                                    </Box>
                                  </Flex>
                                ))}
                              </VStack>
                            )}
                          </VStack>
                        );
                      })}

                      {isAiLoading && (
                        <Flex justify="flex-start" gap={3}>
                          <Box w={8} h={8} borderRadius="full" bg="purple.500" display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
                            <Icon as={FaBrain} color="white" w={4} h={4} />
                          </Box>
                          <Box>
                            <Text fontSize="xs" color={textColor} fontWeight="bold" mb={0.5}>🤖 AI Tutor</Text>
                            <HStack spacing={1} mt={1}>
                              <Box w="6px" h="6px" bg="purple.400" borderRadius="full" className="pulse-animation" style={{ animationDelay: '0s' }} />
                              <Box w="6px" h="6px" bg="purple.400" borderRadius="full" className="pulse-animation" style={{ animationDelay: '0.2s' }} />
                              <Box w="6px" h="6px" bg="purple.400" borderRadius="full" className="pulse-animation" style={{ animationDelay: '0.4s' }} />
                            </HStack>
                          </Box>
                        </Flex>
                      )}
                    </VStack>
                  </Box>

                  <Box p={4} borderTop="1px solid" borderColor={boxBorderColor}>
                    <HStack mb={2}>
                      <label style={{ display: 'flex', alignItems: 'center', fontSize: '11px', color: askAiTextColor, cursor: 'pointer', fontWeight: '600' }}>
                        <input type="checkbox" checked={askAi} onChange={(e) => setAskAi(e.target.checked)} style={{ marginRight: '6px' }} />
                        Ask AI Tutor to reply
                      </label>
                    </HStack>
                    <HStack bg={chatInputBg} borderRadius="full" p={1} pl={4}>
                      <Input 
                        value={aiInput}
                        onChange={(e) => setAiInput(e.target.value)}
                        placeholder="Write your message..."
                        size="sm"
                        variant="unstyled"
                        color={textColor}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleSendAi();
                          }
                        }}
                      />
                      <IconButton 
                        icon={<Icon as={FaPlayCircle} w={5} h={5} />} 
                        colorScheme="purple" 
                        variant="ghost" 
                        isRound 
                        isLoading={isAiLoading}
                        onClick={() => handleSendAi()}
                        isDisabled={!aiInput.trim()}
                        aria-label="Send"
                      />
                    </HStack>
                  </Box>
                </Flex>
              </DrawerBody>
            </DrawerContent>
          </Drawer>

          {/* Seamless Curriculum Playlist */}
          <Box>
            <Heading size="md" mb={4} color={textColor}>Course Playlist</Heading>
            <Stack spacing={2} maxH={{ base: "300px", xl: "400px" }} overflowY="auto" pr={2} sx={{ '&::-webkit-scrollbar': { width: '0px' } }}>
              {res?.course?.sections?.map((section, index) => {
                const isCompleted = enrollment?.completedSections?.some(id => id.toString() === section._id.toString());
                const isThisSectionLocked = (!isCreatorOrAdmin && res?.course?.isLocked) || (section.type === 'quiz' && isFinalQuizLocked);

                return (
                  <Flex 
                    key={index} 
                    p={3}
                    borderRadius="xl"
                    cursor={((enrollment && !isThisSectionLocked) || isCreatorOrAdmin) ? "pointer" : "not-allowed"}
                    bg={selectedSection?._id === section._id ? playlistActiveBg : playlistBg}
                    _hover={(enrollment && !isThisSectionLocked) ? { bg: playlistHoverBg } : {}}
                    transition="all 0.2s"
                    align="center" 
                    gap={4}
                    border={selectedSection?._id === section._id ? "2px solid" : "1px solid"}
                    borderColor={selectedSection?._id === section._id ? "purple.400" : "transparent"}
                    onClick={() => {
                      if (((enrollment && !isThisSectionLocked) || isCreatorOrAdmin)) {
                        setSelectedSection(section);
                      } else if (isThisSectionLocked && section.type === 'quiz') {
                        toast({ title: "Quiz Locked", description: "You must complete all other videos and documents first.", status: "warning", duration: 3000 });
                      }
                    }}
                  >
                    <Box 
                      w="40px" h="40px" 
                      borderRadius="lg" 
                      bg={isThisSectionLocked ? lockedBgColor : (isCompleted ? "green.500" : defaultIconBg)} 
                      display="flex" alignItems="center" justifyContent="center" flexShrink={0}
                    >
                      <Icon 
                        as={isThisSectionLocked ? FaLock : (isCompleted ? FaCheckCircle : (section.type === 'video' ? FaPlayCircle : FaFilePdf))} 
                        color={isThisSectionLocked ? subTextColor : (isCompleted ? "white" : defaultIconColor)} 
                      />
                    </Box>
                    <Box flex={1} overflow="hidden">
                      <Text 
                        fontWeight="bold" 
                        fontSize="sm"
                        isTruncated
                        textDecoration={isCompleted ? "line-through" : "none"}
                        color={isThisSectionLocked ? subTextColor : textColor}
                      >
                        {section.title}
                      </Text>
                      <Text fontSize="xs" color={subTextColor}>{capitalizeFirstLetter(section.type)}</Text>
                    </Box>
                  </Flex>
                );
              })}
            </Stack>

            {/* Quiz Trigger under Playlist */}
            <Box mt={4}>
              {enrollment?.status === 'Completed' ? (
                <Button w="full" colorScheme="green" borderRadius="full" size="sm" onClick={() => {
                  const token = userStore?.token || JSON.parse(localStorage.getItem('user'))?.token;
                  window.open(`${process.env.REACT_APP_API_URL}/api/certificates/${enrollment._id}?token=${token}`, '_blank');
                }}>
                  Download Certificate 🎉
                </Button>
              ) : (
                <VStack spacing={2} w="full">
                  {!res?.course?.sections?.find(s => s.type === 'quiz') ? (
                    <Button colorScheme="purple" variant="outline" w="full" size="sm" borderRadius="full" isDisabled={!enrollment || isGeneratingQuiz} isLoading={isGeneratingQuiz} onClick={handleGenerateQuiz}>
                      {enrollment ? "Generate Final Assessment" : "Enroll to access Quiz"}
                    </Button>
                  ) : (
                    <Button bgGradient="linear(to-r, purple.600, blue.600)" color="white" _hover={{ bgGradient: "linear(to-r, purple.700, blue.700)" }} w="full" size="sm" borderRadius="full" isDisabled={!enrollment || isFinalQuizLocked} onClick={() => {
                      if (isFinalQuizLocked) toast({ title: "Quiz Locked", description: "Complete all modules.", status: "warning", duration: 3000 });
                      else setShowQuiz(true);
                    }}>
                      {isFinalQuizLocked ? "Complete modules to unlock Quiz" : "Take Final Quiz"}
                    </Button>
                  )}
                </VStack>
              )}
            </Box>
          </Box>

        </Box>
      </Flex>

      {/* Horizontal Recommended Courses */}
      {recommendedCourses && recommendedCourses.length > 0 && (
        <Box maxW="1600px" mx="auto" px={{ base: 4, md: 8, xl: 12 }} mt={16}>
          <Heading size="md" mb={6} color={textColor}>Recommended Courses</Heading>
          <Flex 
            gap={6} 
            overflowX="auto" 
            pb={4} 
            sx={{ '&::-webkit-scrollbar': { display: 'none' }, msOverflowStyle: 'none', scrollbarWidth: 'none' }}
          >
            {recommendedCourses.map((c, i) => (
              <Box 
                key={i} 
                minW={{ base: "280px", md: "320px" }} 
                cursor="pointer" 
                onClick={() => navigate(`/course/${c._id}`)}
                role="group"
              >
                <Box h="180px" borderRadius="2xl" overflow="hidden" position="relative" mb={3}>
                  {c.thumbnail || c.img ? (
                    <img src={c.thumbnail || c.img} alt={c.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }} className="course-image" />
                  ) : (
                    <Flex 
                      w="full" h="full" 
                      background="linear-gradient(135deg, #2563eb 0%, #0ea5e9 100%)" 
                      position="relative" align="center" justify="center" p={4} textAlign="center"
                    >
                      <Box position="absolute" top={0} left={0} right={0} bottom={0} bgImage="url('/logo-2.png')" bgSize="50%" bgRepeat="no-repeat" bgPos="center" opacity={0.15} zIndex={0} style={{ mixBlendMode: 'overlay' }} />
                      <Text fontFamily="Outfit" fontSize="sm" fontWeight="800" color="white" lineHeight="1.2" position="relative" zIndex={1}>{c.title}</Text>
                    </Flex>
                  )}
                  <Box position="absolute" top={0} left={0} w="full" h="full" bg="blackAlpha.200" transition="all 0.3s" _groupHover={{ bg: "transparent" }} />
                  {c.isInviteOnly && (
                    <Badge position="absolute" top={3} right={3} colorScheme="red" borderRadius="md" px={2}>Invite Only</Badge>
                  )}
                </Box>
                <Heading size="sm" noOfLines={2} color={textColor} mb={1}>{c.title}</Heading>
                <Text fontSize="xs" color={subTextColor}>{c.teacher}</Text>
              </Box>
            ))}
          </Flex>
        </Box>
      )}

      {showQuiz && (
        <Box position="fixed" top={0} left={0} w="100vw" h="100vh" bg={pageBg} zIndex={2000} p={10} overflowY="auto">
          <Button position="absolute" top={5} right={5} colorScheme="red" variant="outline" borderRadius="xl" onClick={() => setShowQuiz(false)}>Close</Button>
          <Quiz 
            courseId={id} 
            quizContent={res?.course?.sections?.find(s => s.type === 'quiz')?.content || []} 
            onComplete={() => {
              setShowQuiz(false);
              getSinglePageData(id);
            }}
            onClose={() => setShowQuiz(false)}
          />
        </Box>
      )}

      {/* Payment removed for Corporate LMS */}



      {/* PREMIUM GLASSMORPHIC OTP VERIFICATION MODAL */}
      <Modal isOpen={isOtpOpen} onClose={onOtpClose} isCentered motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(16px)" bg="blackAlpha.600" />
        <ModalContent 
          borderRadius="3xl" 
          overflow="hidden" 
          boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.5)" 
          border="1px solid" 
          borderColor="whiteAlpha.300"
          bg="rgba(255, 255, 255, 0.85)"
          maxW="md"
          p={4}
        >
          <ModalHeader textAlign="center" pt={8} pb={0}>
            <VStack spacing={4}>
              <Box 
                w={14} 
                h={14} 
                borderRadius="2xl" 
                bg="linear-gradient(135deg, #6B46C1 0%, #4D2DB7 100%)" 
                display="flex" 
                alignItems="center" 
                justifyContent="center"
                boxShadow="0 10px 20px -5px rgba(107, 70, 193, 0.4)"
              >
                <Icon as={FaLock} color="white" w={6} h={6} />
              </Box>
              <VStack spacing={1}>
                <Heading size="md" fontWeight="800" color="gray.800">Unlock Course Access</Heading>
                <Text fontSize="xs" color="gray.500" fontWeight="600">Enterprise Invite Verification</Text>
              </VStack>
            </VStack>
          </ModalHeader>
          <ModalCloseButton color="gray.400" borderRadius="full" top={6} right={6} />
          
          <ModalBody py={6} px={8}>
            <VStack spacing={6}>
              <Text fontSize="sm" color="gray.600" textAlign="center" lineHeight="1.6">
                This course is invite-only. Please enter the secure <strong>6-digit passcode (OTP)</strong> dispatched to your ERAM Group corporate mailbox.
              </Text>
              
              <FormControl isInvalid={!!otpError}>
                <Input 
                  placeholder="000000" 
                  value={otpInput}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, '');
                    if (val.length <= 6) setOtpInput(val);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleOtpSubmit();
                  }}
                  textAlign="center"
                  fontSize="2xl"
                  fontWeight="800"
                  letterSpacing="8px"
                  h="60px"
                  bg="white"
                  borderRadius="2xl"
                  border="2px solid"
                  borderColor="gray.200"
                  boxShadow="inner"
                  _focus={{ borderColor: "purple.500", boxShadow: "0 0 0 1px #6B46C1" }}
                />
                {otpError && (
                  <Text fontSize="xs" fontWeight="700" color="red.500" mt={2} textAlign="center">
                    ⚠️ {otpError}
                  </Text>
                )}
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter pb={8} px={8} pt={0} justifyContent="center" gap={3}>
            <Button 
              variant="ghost" 
              onClick={onOtpClose} 
              borderRadius="xl" 
              h="50px" 
              px={6}
              fontSize="sm" 
              fontWeight="700" 
              color="gray.500"
            >
              Cancel
            </Button>
            <Button 
              className="premium-gradient hover-lift" 
              color="white" 
              h="50px" 
              px={8}
              fontSize="sm"
              fontWeight="700"
              borderRadius="xl"
              onClick={handleOtpSubmit}
              isLoading={isOtpSubmitting}
              loadingText="Verifying..."
            >
              Verify & Unlock
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
